// extracted by mini-css-extract-plugin
export default {"barLabel":"TasklList_barLabel__p5juO","barLabelOutside":"TasklList_barLabelOutside__NfYBJ"};